import { IconArrowUpRight, IconCurrencyRupee, IconSparkleHighlight } from "@tabler/icons-react"
import { useEffect, useState } from "react";
import { formatAmountInAlphabets, putCommaInLeadsValue } from "../Utils/helpers/commonhelper";
import { GetRequest, UpdateRF } from "../Utils/hooks/ApiHandler";
import useLocalStorageState from "use-local-storage-state";
import { useNavigate } from "react-router-dom";
import { Button, Placeholder } from "react-bootstrap";

export const Subscription = () => {
    const [currentToggle, setCurrentToggle] = useState(false)

    const [planDetails, setPlanDetails] = useState({})
    const [customer, setCustomer] = useLocalStorageState("customer")
    const navigate = useNavigate()

    const customerId = customer?.customer_details?.customer_id;
    const LoginUserId = customer?.customer_details?.id;

    const token = customer?.token?.authorization
    const rf = customer?.token?.authentication

    // API headers configuration
    const headers = {
        Authentication: rf,
        Authorization: token,
    }

    const extras = {
        customer,
        setCustomer,
        rf,
        navigate,
    }
    const logout = () => {
        UpdateRF(customer?.token?.authentication);

        setCustomer({
            customer_details: {},
            customer_status: "Inactive",
            user_login: false,
            token: {},
        });

        localStorage.clear();
        navigate('/login', { replace: true });
    };

    useEffect(() => {
        if (!customer || !customerId || !LoginUserId) {
            console.log('hither')
            logout();
            return;
        }
    }, []);
    const isPlan = customer?.customer_details?.is_plan === 'yes' ? true : false
    useEffect(() => {
        (async () => {
            try {
                const res = await GetRequest('/plan/fetchAllPlan', { headers }, extras);
                if (res.status === 'fail' || res.success === false) return;

                const mapped = {};
                res.data.forEach(item => {
                    mapped[item.name] = item;
                });

                setPlanDetails(mapped);
            } catch (error) {
                return
            }
        })();
    }, []);
    return (
        <>
            <div className="d-flex flex-column align-items-center justify-content-center" style={{
                width: "full",
                minHeight: "100dvh",
                padding: "2rem",
                background: `
                    radial-gradient(circle at 15% 10%, rgba(0,127,255,0.07) 0%, transparent 28%),
                    radial-gradient(circle at 85% 15%, rgba(97,171,24,0.06) 0%, transparent 25%),
                    radial-gradient(circle at 50% 100%, rgba(122,58,94,0.05) 0%, transparent 35%),
                    linear-gradient(180deg, #fafcff 0%, #f7f9fc 100%)
                `,
            }}>
                <div className="mt-4">
                    <div className="d-flex position-relative  " >
                        <header className="text-center mb-5 ">
                            <h1 className="headingClass mb-4" >Choose the Perfect Plan for Your Buisness</h1>
                            <span
                                style={{
                                    display: "inline-block",
                                    maxWidth: "45rem",
                                    lineHeight: "1.6",
                                }}
                            >
                                PugCRM provides flexible pricing plans for businesses of all sizes, with tools and insights to support growth and success, whether you're starting or scaling.
                            </span>
                        </header>
                        <div
                            className="position-absolute d-flex align-items-center gap-2"
                            style={{
                                right: '-20rem',
                                top: 0,
                            }}
                        >
                            {isPlan && (
                                <button
                                    type="button"
                                    onClick={() => navigate("/dashboard")}
                                    className="subscription-action-btn dashboard-btn">
                                    Return to Dashboard
                                </button>
                            )}

                            <button
                                onClick={() => {
                                    UpdateRF(customer.token?.authentication);
                                    setCustomer({});
                                    localStorage.clear()
                                    navigate('/login')
                                }}
                                className="subscription-action-btn logout-btn"
                            >
                                Logout
                            </button>
                        </div>
                    </div>
                    <style jsx>
                        {`
                            .headingClass {
                                font-size : 3.2rem !important;
                                font-weight : 600 !important;
                            }
                            .subscription-action-btn {
                                border-radius: 12px;
                                padding: 10px 16px;
                                font-size: 0.9rem;
                                font-weight: 500;
                                background: rgba(255,255,255,0.65);
                                backdrop-filter: blur(8px);
                                transition: all .25s ease;
                            }

                            .dashboard-btn {
                                border: 1px solid rgba(0,127,255,.12);
                                color: #24324a;
                            }

                            .logout-btn {
                                border: 1px solid rgba(122,58,94,.12);
                                color: #7a3a5e;
                            }

                            .subscription-action-btn:hover {
                                transform: translateY(-2px);
                            }
                        `}
                    </style>
                    <div className="d-flex align-items-center justify-content-center gap-2">
                        <span style={{ color: `${!currentToggle ? "#007fff" : "black"}`, display: "inline-block", fontWeight: 600, fontSize: "1.4rem" }}>Monthly</span>

                        <button
                            type="button"
                            onClick={() => setCurrentToggle(!currentToggle)}
                            style={{
                                width: "44px",
                                height: "24px",
                                borderRadius: "20px",
                                backgroundColor: currentToggle ? "#7a3a5e" : "#e2e8f0",
                                cursor: "pointer",
                                padding: "3px",
                                position: "relative",
                                border: "none",
                                transition: "background-color 0.3s"
                            }}
                        >
                            <div
                                style={{
                                    width: "18px",
                                    height: "18px",
                                    borderRadius: "50%",
                                    backgroundColor: "white",
                                    position: "absolute",
                                    left: currentToggle ? "calc(100% - 21px)" : "3px",
                                    top: "3px",
                                    transition: "left 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
                                    boxShadow: "0 1px 3px rgba(0,0,0,0.15)",
                                }}
                            />
                        </button>

                        <span style={{ color: `${currentToggle ? "#007fff" : "black"}`, display: "inline-block", fontWeight: 600, fontSize: "1.4rem" }}>Yearly</span>

                    </div>
                </div>

                <div className="d-flex align-items-center justify-content-evenly mt-5" style={{ width: "100%" }}>
                    {Object.keys(planDetails)?.length === 0 ? (
                        Array.from({ length: 3 }).map((_, index) => (
                            <PlanCardSkeleton key={index} />
                        ))
                    ) : (
                        Object.entries(planDetails).map(([k, value]) => (
                            <PlanCard
                                key={k}
                                planDetails={value}
                                pricing={currentToggle ? value?.pricing[1] : value?.pricing[0]}
                                isPopular={Number(value["popular"]) === 0 ? false : true}
                                currentToggle={currentToggle}
                            />
                        ))
                    )}
                </div>
            </div >
        </>
    )
}


const PlanCardSkeleton = () => {
    return (
        <div
            style={{
                width: "26rem",
                height: "35rem",
                borderRadius: "1rem",
                padding: "2rem",
                background:
                    "linear-gradient(135deg, rgba(0,127,255,0.03) 0%, rgba(255,255,255,1) 35%, rgba(122,58,94,0.04) 100%)",
                border: "2px solid rgba(0,0,0,0.06)",
                boxShadow: "0 4px 16px rgba(0,0,0,0.04)",
            }}
        >
            <Placeholder as="div" animation="glow">
                <Placeholder xs={4} style={{ height: "28px", borderRadius: "8px" }} />
            </Placeholder>

            <div className="mt-4">
                <Placeholder as="div" animation="glow">
                    <Placeholder xs={3} style={{ height: "18px" }} />
                </Placeholder>

                <Placeholder as="div" animation="glow" className="mt-3">
                    <Placeholder xs={6} style={{ height: "48px", borderRadius: "8px" }} />
                </Placeholder>
            </div>

            <Placeholder.Button
                animation="glow"
                variant="light"
                style={{
                    width: "70%",
                    height: "44px",
                    borderRadius: "1.5rem",
                    marginTop: "1rem",
                }}
            />

            <div className="mt-4 d-grid" style={{ gap: "0.75rem", }}>
                {Array.from({ length: 5 }).map((_, idx) => (
                    <Placeholder key={idx} as="div" animation="glow" >
                        <Placeholder xs={8} />
                    </Placeholder>
                ))}
            </div>
        </div>
    )
}

const PlanCard = ({ planDetails, isPopular, pricing, currentToggle }) => {
    let [totalAmt, setTotalAmt] = useState(0)
    const navigate = useNavigate()
    useEffect(() => {
        if ((pricing?.discount_type === "flat" || pricing?.discount_type === "PERCENT") && Number(pricing?.discount) === 0) {
            setTotalAmt(pricing?.amount)
            return
        } else if (pricing?.discount_type === "flat") {
            setTotalAmt(Number(pricing?.amount) - Number(pricing?.discount))
            return
        } else {
            setTotalAmt(((Number(pricing?.amount) / 100) * Number(pricing?.discount)))
            return
        }

    }, [currentToggle])

    const featuresArr = planDetails?.modules?.map(c => Object.values(c)[0]) || []
    return (
        <div
            className={`position-relative hoverEff ${planDetails?.popular === "1" ? "popular-card" : "standard-card"
                }`}
            style={{ animation: "cardEntry 1s ease-out forwards" }}
        >
            <div
                className=" d-flex flex-column align-items-start"
                style={{
                    width: "26rem",
                    height: "35rem",
                    background: planDetails?.popular === "1"
                        ? "linear-gradient(135deg, rgba(97,171,24,0.08) 0%, rgba(255,255,255,1) 45%, rgba(0,127,255,0.05) 100%)"
                        : "linear-gradient(135deg, rgba(0,127,255,0.03) 0%, rgba(255,255,255,1) 35%, rgba(122,58,94,0.04) 100%)",

                    border: planDetails?.popular === "1"
                        ? "2px solid rgba(97,171,24,0.18)"
                        : "2px solid rgba(0,0,0,0.06)",

                    boxShadow: planDetails?.popular === "1"
                        ? "0 8px 24px rgba(97,171,24,0.08)"
                        : "0 4px 16px rgba(0,0,0,0.04)",

                    borderRadius: "1rem",
                    position: "relative",
                    overflow: "hidden",
                    backdropFilter: "blur(8px)",
                    padding: "2rem",
                    paddingRight: '2rem',
                }}
            >
                <h6
                    style={{
                        fontSize: "1.5rem",
                        fontWeight: "600",
                        marginBottom: "0.8rem",
                        color: planDetails?.popular === "1" ? "#1c1c1c" : "#24324a",
                    }}
                    className="d-flex align-items-center gap-3"
                >
                    {planDetails?.name} Plan
                    {planDetails?.popular === "1" &&
                        <span
                            className="px-3 py-2 d-flex gap-2 align-items-center"
                            style={{
                                display: "inline-block",
                                borderRadius: "1rem",
                                border: 'none',
                                background: "#e9f0e3",
                                color: "#61ab18",
                                fontSize: '0.825rem',
                                letterSpacing: "0.5px"
                            }}>
                            <IconSparkleHighlight size={16} /> Popular
                        </span>}
                </h6>

                <div className="d-flex flex-column gap-1 mt-4 mb-1">
                    {
                        Number(pricing?.discount) !== 0 &&
                        <p
                            style={{
                                textDecoration: "line-through",
                                fontSize: "1.1rem",
                                color: "black",
                                fontWeight: "500",
                                marginBottom: "0.8rem"
                            }}
                        >
                            ₹ {(pricing?.amount).toLocaleString()} per month
                        </p>
                    }

                    <div
                        className="d-flex gap-2 align-items-baseline"
                        style={{ marginBottom: "1.2rem" }}
                    >
                        <IconCurrencyRupee
                            size={22}
                            stroke={2}
                            style={{
                                color: "black"
                            }}
                        />
                        <p
                            style={{
                                fontSize: "2.4rem",
                                fontWeight: "bold",
                                color: planDetails?.popular === "1" ? "#1c1c1c" : "#24324a"
                            }}
                        >
                            {`${(totalAmt).toLocaleString("en")}`} <span style={{ fontSize: "1rem", fontWeight: "500" }}>per month</span>
                        </p>
                    </div>
                </div>

                <button
                    style={{
                        fontSize: "1rem",
                        fontWeight: "600",
                        color: planDetails?.popular === "1" ? "white" : "black",
                        borderRadius: "1.5rem",
                        border: planDetails?.popular === "1"
                            ? "1px solid transparent"
                            : "1px solid rgba(0,127,255,0.12)",
                        background: planDetails?.popular === "1"
                            ? "linear-gradient(135deg, #61ab18 0%, #4f9712 100%)"
                            : "linear-gradient(135deg, rgba(0,127,255,0.04) 0%, rgba(122,58,94,0.05) 100%)",
                        boxShadow: planDetails?.popular === "1"
                            ? "0 6px 18px rgba(97,171,24,0.18)"
                            : "none",
                        width: "70%",
                        padding: "10px 10px",
                        transition: "all 0.25s ease",
                        position: "relative",
                        overflow: "hidden",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                    className={`cta-btn ${planDetails?.popular === "1" ? "popular-plan-btn" : ""}`}
                    onClick={() => navigate("/planSummary", {
                        state: {
                            selectedPlan: planDetails?.name,
                            planDetails: planDetails,
                            pricing: pricing,
                            totalAmount: totalAmt
                        }
                    })}
                >

                    <span className="cta-text">Get Started</span>

                    <span className="cta-icon">
                        <IconArrowUpRight size={18} stroke={2.2} />
                    </span>

                </button>

                <style>
                    {`
                        .cta-text {
                        transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
                        }

                        .cta-icon {
                            position: absolute;
                            right: calc(50% - 58px);
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            opacity: 0;
                            transform: translateX(-18px) translateY(82px);
                            transition:
                                transform 0.3s cubic-bezier(0.4, 0, 0.2, 1),
                                opacity 0.3s ease;
                        }

                        .cta-btn:hover .cta-text {
                            transform: translateX(-12px);
                        }

                        .cta-btn:hover .cta-icon {
                            opacity: 1;
                            transform: translateX(0) translateY(0);
                        }
                        .hoverEff {
                            border-radius: 1rem;
                            transition:
                                transform 0.3s ease,
                                box-shadow 0.3s ease;
                        }

                        .hoverEff:hover {
                            transform: translateY(-6px);
                        }

                        .standard-card:hover {
                            box-shadow:
                                0 18px 40px rgba(0, 0, 0, 0.06),
                                0 0 24px rgba(0, 127, 255, 0.08);
                        }

                        .popular-card:hover {
                            box-shadow:
                                0 18px 40px rgba(0, 0, 0, 0.08),
                                0 0 28px rgba(97, 171, 24, 0.14);
                        }
                    `}
                </style>
                <div
                    style={{
                        display: "grid",
                        gridTemplateRows: "repeat(8, auto)",
                        gridAutoFlow: "column",
                        gap: "0.4rem 2rem",
                        marginTop: "1rem",
                        textAlign: "left",
                    }}
                >
                    {featuresArr.map((c, i) => (
                        <p key={i} style={{ margin: 0, fontSize: "0.7rem", color: "black", textWrap: "nowrap" }}>
                            <span style={{ fontSize: "0.7rem", width: "1rem", display: "inline-block" }}>
                                ✓
                            </span>
                            {c}
                        </p>
                    ))}
                </div>
            </div>
        </div >
    )
}